import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faXTwitter,
  faWhatsapp,
  faPinterest,
} from "@fortawesome/free-brands-svg-icons";

import "./SharePopup.css";

const SharePopup = ({ isOpen, onClose, shareUrl,shareImg, shareTitle, shareText,filename }) => {
  const [copied, setCopied] = useState(false);
  const [imgcopied, setimgcopied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [imageBlob, setImageBlob] = useState(null);
  const [fileObj, setFileObj] = useState(null);
  const [canNativeImageShare, setCanNativeImageShare] = useState(false);
  const [canDesktopImageCopy, setCanDesktopImageCopy] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);

  useEffect(() => {
    const mobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    setIsMobile(mobile);

    const loadImage = async () => {
      setImageLoading(true);
      try {
        // Fetch the image with CORS mode
        const res = await fetch(shareImg, { mode: 'cors' });
        const blob = await res.blob();
        setImageBlob(blob);

        const file = new File([blob], `${shareTitle}.jpg`, { type: blob.type });
        setFileObj(file);

        // Check if clipboard API is available
        if (navigator.clipboard && window.ClipboardItem) {
          setCanDesktopImageCopy(true);
        }

        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          setCanNativeImageShare(true);
        }
      } catch (e) {
        console.warn("Image load failed:", e);
      } finally {
        setImageLoading(false);
      }
    };

    if (shareImg && isOpen) {
      loadImage();
    }
  }, [shareImg, shareTitle, isOpen]);

  if (!isOpen) return null;

  const handleCopyLink = async () => {
    try {

      const randomStr = Math.random().toString(36).substring(2, 8); 

      const fullText = `${shareUrl}`;
      await navigator.clipboard.writeText(fullText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const handleCopyImageDesktop = async () => {
    // If image is still loading, wait for it
    if (imageLoading) {
      console.log("Image still loading, please wait...");
      return;
    }

    // Check if we have the image blob and clipboard support
    if (!imageBlob || !canDesktopImageCopy) {
      console.warn("Image or clipboard not available, copying link instead");
      return handleCopyLink();
    }

    try {
      // Fetch fresh image data from shareUrl
      const response = await fetch(shareImg, { mode: 'cors' });
      const freshBlob = await response.blob();

      // Convert to PNG for better clipboard compatibility
      const img = new Image();
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      // Create object URL for the blob
      const objectUrl = URL.createObjectURL(freshBlob);
      
      // Wait for image to load
      await new Promise((resolve, reject) => {
        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          
          canvas.toBlob(async (pngBlob) => {
            if (pngBlob) {
              try {
                // Copy the PNG blob to clipboard
                // await navigator.clipboard.write([
                //   new ClipboardItem({ 
                //     'image/png': pngBlob 
                //   }),
                // ]);

                await navigator.clipboard.write([
                    new ClipboardItem({
                      'text/html': new Blob([
                        `<a href="${shareUrl}"><img src="${shareImg}"/></a>`
                      ], { type: 'text/html' }),
                      'text/plain': new Blob([shareUrl], { type: 'text/plain' })
                    })
                  ]);


                await navigator.clipboard.writeText(shareUrl);
                
                setimgcopied(true);
                setTimeout(() => setimgcopied(false), 2000);
                resolve();
              } catch (clipErr) {
                reject(clipErr);
              }
            } else {
              reject(new Error('Failed to convert image to PNG'));
            }
          }, 'image/png');
        };
        
        img.onerror = () => reject(new Error('Failed to load image'));
        img.src = objectUrl;
      });
      
      // Clean up object URL
      URL.revokeObjectURL(objectUrl);

    } catch (err) {
      console.error("Image copy failed:", err);
      // Fallback to copying link if image copy fails
      handleCopyLink();
    }
  };

   const handleNativeShare = async () => {
          if (!navigator.share) return;

          setLoading(true);

          try {

            const randomStr = Math.random().toString(36).substring(2, 8); 

            const fullText = `${shareUrl}?${randomStr}`;

            await navigator.share({
              url: fullText,
            });
          } catch (err) {
            if (err.name !== 'AbortError') {
              console.error("Native share error:", err);
            }
          }

          setLoading(false);
      };

  const getCacheBustedUrl = (url) => {
    if (!url) return url;
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}v=${Date.now()}`;
  };

  const handleSocialShare = async (platform) => {
    setLoading(true);

    try {
      const encodedUrl2 = encodeURIComponent(shareUrl);

      const encodedUrl = getCacheBustedUrl(encodedUrl2);

      const encodedText = encodeURIComponent(shareText);
      const encodedTitle = encodeURIComponent(shareTitle);

      let shareLink = "";

      switch (platform) {

        case "facebook":

          // console.log(shareUrl);

          const encodedPageUrl = encodeURIComponent(shareUrl);

          console.log(shareUrl);
            // const sta_url = "https://personalitypeek.com/api/og-images/dimension/Wk96ySCTSYV3Xu6Nva2VFJUAEnn2FY1V0E5Gg5lZ.jpg";

            const sta_url ="https://res.cloudinary.com/dct2st2uk/image/upload/v1771497069/file_2_w5u1rf.jpg";

            shareLink = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;

          // const imageUrl = `https://personalitypeek.com/og/dimension/${encodeURIComponent(filename)}`;

          // Facebook share using image URL directly

          // console.log(imageUrl);

          //  shareLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(imageUrl)}`;

          //  console.log(shareLink);

          // window.open(facebookShareUrl, '_blank');
          break;

        case "linkedin":

           const encodedLinkedMedia = encodeURIComponent(shareUrl);

          // shareLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedLinkedMedia}?redirect`;

          // shareLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}&title=${encodedTitle}&summary=${encodedText}&source=${encodedUrl}`;

          // shareLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedLinkedMedia}&title=${encodedTitle}&summary=${encodedText}`;

          shareLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;

          break;

        case "twitter":

            const encodedTwitterUrl = encodeURIComponent(shareUrl);
            const hashtags = "personalitypeek";

           shareLink = `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedTwitterUrl}&v2`;
          break;

        case "pinterest":
  
        const encodedMedia = encodeURIComponent(shareImg || shareUrl);
        shareLink = `https://pinterest.com/pin/create/button/?url=${encodedUrl}&media=${encodedMedia}&description=${encodedTitle}`;
        break;

        case "whatsapp":
          shareLink = isMobile
            ? `whatsapp://send?text=${encodedTitle}%0A${encodedText}%0A${encodedUrl}`
            : `https://web.whatsapp.com/send?text=${encodedTitle}%0A${encodedText}%0A${encodedUrl}`;
          break;

        case "instagram":
          if (!isMobile) {
            await handleCopyImageDesktop();
            setLoading(false);
            return;
          }

          try {
            if (imageBlob) {
              await navigator.clipboard.write([
                new ClipboardItem({ [imageBlob.type]: imageBlob }),
              ]);
            }
          } catch {
            await handleCopyLink();
          }

          setLoading(false);
          return;

        default:
          return;
      }

      window.open(shareLink, "_blank", "width=600,height=400");
    } catch (err) {
      console.error("Share error:", err);
    }

    setLoading(false);
  };

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-box" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <h3 className="popup-title">Share Result</h3>

        {loading && <div className="loading-spinner">Please wait...</div>}

        {isMobile && navigator.share && (
          <button className="native-share-btn" onClick={handleNativeShare}>
            📤 {canNativeImageShare ? "Share via Device" : "Share via Device"}
          </button>
        )}

        {!isMobile || !navigator.share ? (
          <>
            {/* {canDesktopImageCopy && (
              <button 
                className="copy-btn" 
                onClick={handleCopyImageDesktop}
                disabled={imageLoading}
              >
                {imageLoading ? "⏳ Loading..." : imgcopied ? "✓ Image Copied!" : "📸 Copy Image"}
              </button>
            )} */}

            <div className="social-grid">
              <button onClick={() => handleSocialShare("facebook")} className="social-btn">
                <FontAwesomeIcon icon={faFacebook} className="fb" />
                <span>Facebook</span>
              </button>

              <button onClick={() => handleSocialShare("linkedin")} className="social-btn">
                <FontAwesomeIcon icon={faLinkedin} className="li" />
                <span>LinkedIn</span>
              </button>

              <button onClick={() => handleSocialShare("twitter")} className="social-btn">
                <FontAwesomeIcon icon={faXTwitter} className="tw" />
                <span>X</span>
              </button>

              <button onClick={() => handleSocialShare("pinterest")} className="social-btn">
                <FontAwesomeIcon icon={faPinterest} className="pi" />
                <span>Pinterest</span>
              </button>

            </div>
          </>
        ) : null}

        <button className="copy-btn" onClick={handleCopyLink}>
          {copied ? "✓ Copied!" : "Copy Link"}
        </button>
      </div>
    </div>
  );
};

export default SharePopup;